<div class="w-100 h-100">
    <div class="sb-options mb-2">
        <sb-generic-type-select
            appearance="none"
            label="Group by"
            [valueKey]="false"
            [options]="typeOptions"
            [formControl]="typeCtrl"
        ></sb-generic-type-select>
        <sb-period-picker label="Period" [formControl]="periodCtrl"></sb-period-picker>
        <sb-breadcrumbs
            [disabled]="isLoading$ | async"
            class="mx-n3"
            [breadcrumbs]="breadcrumbs$ | async"
            useRouterEvents="false"
        ></sb-breadcrumbs>
        <sb-key-metrics
            forceHorizontal="true"
            [metrics]="metrics$ | async"
        ></sb-key-metrics>
    </div>
    <app-bb-chart
        [fitHeightToParent]="fitHeightToParent"
        [options]="chartOptions"
        (chartRef)="chartRef = $event"
        [data]="chartData$ | async"
        [loading]="isLoading$ | async"
        (loadingChange)="isLoading = $event"
        cursorPointer="true"
        [style.--number-of-categories]="numberOfCategories$ | async"
    >
        <div class="skeleton-loader skeleton-loader-chart-bar mt-4" aria-busy="true">
            <span class="visually-hidden">Loading value bridge...</span>
        </div>
    </app-bb-chart>
</div>
<sb-pro-tip
    id="sb-value-bridge"
    heading="Value bridge"
    class="position-sticky z-1"
    fitToContainer="true"
>
    <p>
        View market value changes over time by account or asset type for a given period.
        Hover the bars to view market value change per group and click to see how that
        change is distributed across different holdings.
    </p>
</sb-pro-tip>
